import React from "react";
import { MDBIcon } from "mdb-react-ui-kit";

function Footer(props) {
  return (
    <>
      <div className="container">
        <div>
          <script
            async
            src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4521565878522096"
            crossorigin="anonymous"
          ></script>

          <ins
            class="adsbygoogle"
            style={{ display: "block" }}
            data-ad-client="ca-pub-4521565878522096"
            data-ad-slot="7595526868"
            data-ad-format="auto"
            data-full-width-responsive="true"
          ></ins>
          <script>(adsbygoogle = window.adsbygoogle || []).push({});</script>
        </div>
        <footer className="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top">
          <div className="col-md-4 d-flex align-items-center">
            <span
              className={`mb-3 mb-md-0 text-${
                props.mode === "light" ? "dark" : "light"
              } `}
              style={{
                fontSize: "15px",
                fontFamily: "sans-serif",
                fontVariant: "small-caps",
                fontWeight: 600,
              }}
            >
              Made with{" "}
              <MDBIcon style={{ color: "red" }} fas icon="a-solid fa-heart" />{" "}
              in Goa
            </span>
          </div>

          <ul className="nav col-md-4 justify-content-end list-unstyled d-flex">
            <li
              className={`mb-3 ms-3 mb-md-0 text-${
                props.mode === "light" ? "dark" : "light"
              } `}
            >
              &copy; 2022{" "}
              <span
                style={{
                  fontSize: "20px",
                  fontFamily: "sans-serif",
                  fontVariant: "small-caps",
                  fontWeight: 600,
                }}
              >
                Texti
              </span>
            </li>
          </ul>
        </footer>
      </div>
    </>
  );
}

export default Footer;
